// extracted by mini-css-extract-plugin
module.exports = {"ltvOption":"styles_ltvOption___1Zkn","ltvOptionSelected":"styles_ltvOptionSelected___IO4c"};